module.exports = __webpack_public_path__ + "img/Flag_of_Bermuda.ad53f11a.svg";